module.exports = __webpack_public_path__ + "static/media/drightArrow.9a1b4c18.svg";